/**
 * "Upcoming feature": the label a public page or menu item carries while its
 * feature is released in stages (Admin › Releases). It disappears by itself
 * once the release goes Live for everyone. The live list is empty until read,
 * so the prerendered HTML and the first client render both show the badge.
 */
import { useLiveReleases } from "@/hooks/useFeatureAccess";
import { cn } from "@/lib/utils";

export function UpcomingBadge({ release, short = false, className }: { release?: string; short?: boolean; className?: string }) {
  const { data: live } = useLiveReleases();
  if (release && live?.has(release)) return null;
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-[hsl(var(--ec-blue)/0.45)] bg-[hsl(var(--ec-blue)/0.12)] font-semibold text-[hsl(var(--ec-blue))]",
        short ? "px-1.5 py-px text-[9.5px] uppercase tracking-wider" : "px-2.5 py-1 text-[11.5px]",
        className,
      )}
    >
      {!short && <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-[hsl(var(--ec-blue))]" />}
      {short ? "Upcoming" : "Upcoming feature"}
    </span>
  );
}

export default UpcomingBadge;
